import i18next from 'i18next';

const errorMessage = 'Một lỗi đã xảy ra. Vui lòng thử lại sau.';

export const getDefaultErrorMessage = () =>
    i18next.t(errorMessage) || errorMessage;
